var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 1.61px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.5,17.7l-13.52,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.11,9.47l-.45-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.36,13.34l-.56-1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3,6.03l-.37-1.14-.1-.31c-.04-.13.04-.29.15-.31l4.14-.7.62.42,5.95,4.05-2.18-4.4-.37-.76,4.12-.89c.15-.03.29.04.37.18l6.59,12.6c.05.08-.03.24-.13.27l-.98.3-.1.03-2.72.84-7.54-4.75,2.23,6.32-4.99,1.62c-.2.06-.38-.04-.45-.24l-.08-.26-1.05-3.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.12,9.97c-.28-.91.47-1.95,1.67-2.32.69-.21,1.37-.15,1.89.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.16,13.72c-.28-.91.47-1.95,1.67-2.32.69-.21,1.37-.15,1.89.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.3,17.41c-.28-.91.47-1.95,1.67-2.32.69-.21,1.37-.15,1.89.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/Notebook.d93bd065cbf0e0614f389c39b85a560d.svg";
export { ForwardRef as ReactComponent };